import { render, staticRenderFns } from "./PartnershipsPanel.vue?vue&type=template&id=47c5575c&scoped=true&"
import script from "./PartnershipsPanel.vue?vue&type=script&lang=js&"
export * from "./PartnershipsPanel.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipsPanel.vue?vue&type=style&index=0&id=47c5575c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c5575c",
  null
  
)

export default component.exports